import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'influencerRegions',
  urlRoot: '/influencer_regions'
})
